export const ROLES = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  CASHIER: 'CASHIER',
};

export const ROLE_LEVELS = {
  [ROLES.CASHIER]: 1,
  [ROLES.ADMIN]: 2,
  [ROLES.SUPER_ADMIN]: 3,
};

// Effective permission hierarchy. A higher role inherits all lower-role capabilities.
export const ROLE_HIERARCHY = {
  [ROLES.CASHIER]: [ROLES.CASHIER],
  [ROLES.ADMIN]: [ROLES.ADMIN, ROLES.CASHIER],
  [ROLES.SUPER_ADMIN]: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.CASHIER],
};

export const DEFAULT_ROLE = ROLES.CASHIER;
